import React, { memo, useState } from "react";
import { MdPlaylistRemove } from "react-icons/md";
import { IoMdRefresh } from "react-icons/io";
import { BiUndo } from "react-icons/bi";
import ChipsCell from "./ChipsCell";
import CustomButton from "./CustomButton";
const Board = ({
  selectedChips,
  handlePlaceChips,
  board,
  setBoard,
  lastUndoAction,
  handleUndo,
  total,
  balance,
  handleClearBoard,
  resetKey,
  setResetKey,
  setTotal,
}) => {
  const [isRemoveCellActive, setIsRemoveCellActive] = useState(false);
  const handleRemoveCell = (value) => {
    setBoard((prevBoard) =>
      prevBoard.map((row) =>
        row.map((cell) => {
          if (cell.value === value) {
            const totalChipValue = cell.chips.reduce(
              (sum, chip) => sum + chip.value * chip.count,
              0
            );

            return {
              ...cell,
              chips: cell.chips.map((chip) => ({ ...chip, count: 0 })),
            };
          }
          return cell;
        })
      )
    );

    setTotal((prevTotal) => {
      const cellToRemove = board.flat().find((cell) => cell.value === value);
      if (!cellToRemove) return prevTotal;

      const totalChipValue = cellToRemove.chips.reduce(
        (sum, chip) => sum + chip.value * chip.count,
        0
      );

      return Math.max(prevTotal - totalChipValue, 0);
    });
  };
  const handleClearCell = () => {
    setIsRemoveCellActive((x) => !x);
  };
  return (
    <div className="h-auto relative xsm:-top-0 xs:-top-6  2xl:mt-2 xl:-mt-20 xsm:mt-36 xs:mt-72 top-60  md:w-[752px] transform xsm:rotate-0 rotate-90 sm:w-[612px]  xsm:w-[500px] w-full mx-auto">
      <div className="flex  h-fit flex-row md:w-[752px]  sm:w-[612px] xsm:w-[500px] w-[612px]  items-center  gap-x-1">
        <ChipsCell
          resetKey={resetKey}
          isRemoveCellActive={isRemoveCellActive}
          selectedChips={selectedChips}
          className="md:h-[158px] sm:h-[128px] xsm:h-[104px] h-[128px] md:w-[50px] sm:w-10 xsm:w-8 w-10"
          handleClick={() => handlePlaceChips(0)}
          handleRemoveCell={handleRemoveCell}
          color={board[0][0]?.color}
          value={board[0][0]?.value}
          chips={board[0][0]?.chips}
          lastUndoAction={lastUndoAction}
          setResetKey={setResetKey}
          total={total}
          balance={balance}
        />

        <div className="flex   flex-col w-full h-full gap-y-1">
          {board.slice(1, 4).map((row, rowIdx) => {
            return (
              <div key={rowIdx} className="flex flex-row items-center gap-x-1">
                {row.map((item, index) => {
                  return (
                    <ChipsCell
                      resetKey={resetKey}
                      isRemoveCellActive={isRemoveCellActive}
                      selectedChips={selectedChips}
                      handleClick={() => handlePlaceChips(item?.value)}
                      handleRemoveCell={handleRemoveCell}
                      className="md:h-[50px] sm:h-10 xsm:h-8 h-10 md:w-[50px] sm:w-10 xsm:w-8 w-10"
                      key={index}
                      value={item?.value}
                      color={item?.color}
                      chips={item?.chips}
                      lastUndoAction={lastUndoAction}
                      setResetKey={setResetKey}
                      total={total}
                      balance={balance}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex md:w-[752px]  sm:w-[612px] xsm:w-[500px] w-[612px]   mt-1 flex-row gap-x-1">
        <div className="flex flex-col md:w-[48px] sm:w-[38px] xsm:w-[30px] w-10   gap-y-1">
          <CustomButton
            module="button"
            handleClick={handleClearCell}
            icon={
              <MdPlaylistRemove
                className={`text-xl ${
                  isRemoveCellActive && "text-[#200052]"
                } group-hover:text-[#200052]`}
              />
            }
            className="md:h-[50px] sm:h-10 xsm:h-8 h-10 md:w-[48px] sm:w-[38px] xsm:w-[30px] w-[38px]"
          />
          <CustomButton
            module="button"
            handleClick={handleUndo}
            icon={
              <BiUndo
                className={`md:text-xl sm:text-base text-md group-hover:text-[#200052]`}
              />
            }
            value="Undo"
            className="md:h-[50px] sm:h-10 xsm:h-8 h-10 md:w-[48px] sm:w-[38px] xsm:w-[30px] w-10"
          />
        </div>
        <div className="flex flex-col gap-y-1">
          <div className="flex  gap-x-1 items-center">
            {board[4].map((cell, index) => {
              return (
                <CustomButton
                  key={index}
                  value={cell.value}
                  handleClick={() => handlePlaceChips(cell.value)}
                  module="cell"
                  className="md:w-[212px] sm:w-[172px] xsm:w-[140px] w-[172px] md:h-[50px] sm:h-10 xsm:h-8 h-10"
                  color={cell?.color}
                  chips={cell?.chips}
                  selectedChips={selectedChips}
                  isRemoveCellActive={isRemoveCellActive}
                  handleRemoveCell={handleRemoveCell}
                  lastUndoAction={lastUndoAction}
                  setResetKey={setResetKey}
                  resetKey={resetKey}
                  total={total}
                  balance={balance}
                />
              );
            })}
          </div>
          <div className="flex gap-x-1  items-center">
            {board[5].map((cell, index) => {
              return (
                <CustomButton
                  key={index}
                  value={cell.value}
                  handleClick={() => handlePlaceChips(cell.value)}
                  module="cell"
                  color={cell.color}
                  className="md:w-[104px] sm:w-[84px] xsm:w-[68px] w-[84px] md:h-[50px] sm:h-10 xsm:h-8 h-10"
                  chips={cell?.chips}
                  selectedChips={selectedChips}
                  isRemoveCellActive={isRemoveCellActive}
                  handleRemoveCell={handleRemoveCell}
                  lastUndoAction={lastUndoAction}
                  setResetKey={setResetKey}
                  resetKey={resetKey}
                  total={total}
                  balance={balance}
                />
              );
            })}
          </div>
        </div>
        <CustomButton
          handleClick={handleClearBoard}
          icon={
            <IoMdRefresh
              className={`md:text-xl sm:text-base text-md group-hover:text-[#200052]`}
            />
          }
          value="clear"
          className="md:h-[104px] sm:h-[84px] xsm:h-[68px] h-[84px] md:w-[48px] sm:w-[38px] xsm:w-[30px] w-10"
          module="button"
        />
      </div>
    </div>
  );
};

export default Board;
